import { useAppSelector } from 'app/hooks';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { Genre } from 'features/Genre/models/Genre';
import { Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import './Add.scss';
import GenreFormAdd from './components/GenreFormAdd';

interface AddModalInterface {
  show: boolean;
  handleCloseModalAdd?: (status: boolean) => void;
  dataTable?: Genre[] | [];
  setDataTable?: (genres: Genre[]) => void;
}

function AddModal({ show, handleCloseModalAdd, dataTable, setDataTable }: AddModalInterface) {
  const { t } = useTranslation();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  function onHide() {
    handleCloseModalAdd && handleCloseModalAdd(false);
  }

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar title={t('Genre.Headers.title')}></FeatureTitleBar>
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <GenreFormAdd
          show={show}
          handleCloseModalAdd={handleCloseModalAdd}
          dataTable={dataTable}
          setDataTable={setDataTable}
        />
      </Modal.Body>
    </Modal>
  );
}
export default AddModal;
